import { flow, types } from 'mobx-state-tree'
import { toDeleteRegexPhoneNumberMask } from '@linqpal/models/src/helpers/validations'
import { toJS } from 'mobx'

/**
 * For Input Reactions.
 */
export const InputReactionStore = types
  .model({})
  .volatile((self) => ({
    customerInputForceUpdate: 0,
  }))
  .actions((self) => ({
    setCustomerData: flow(function* (businessAccount) {
      self.customer.setValue('contact', businessAccount.contact)
      self.customer.setValue('address', businessAccount.address)
      self.customer.setValue('name', businessAccount.name)
      self.customer.setValue(
        'phone',
        businessAccount.phone.replace(toDeleteRegexPhoneNumberMask, ''),
      )
    }),
    resetInvoiceFields: (fields = [], value = '') =>
      fields.forEach((key) => self.draftModel.setValue(key, value)),
    /**
     * When user selects a Business Name, set the phone number based on this and customer name if it's a single customer.
     */
    setPhoneAndContactFromBusiness(val) {
      const { draftModel: invoice } = self
      if (val) {
        invoice.setValue('customer_account_id', val.id)
        self.setCustomerData(val)
      } else {
        // self.resetInvoiceFields(['cuso', 'customer_contact'])
        invoice.setValue('customer_account_id', '')
        self.customer.setValue('contact', '')
        self.customer.setValue('name', '')
        self.customer.setValue('address', '')
        self.customer.setValue('phone', '')
        self.businessAccountsUsers = []
      }
      self.customerInputForceUpdate += 1
    },
    /**
     * When user inputs a valid phone number check and find if a business has it.
     * If it does automatically set the customer name and business name.
     */
    setBusinessAndCusterNameFromPhone(account) {
      const { draftModel: invoice, businessAccounts } = self
      const customer = toJS(self.customer)
      if (self.customer.isValidPhone) {
        const businessAccount = account
          ? account
          : businessAccounts.find(
              (account) =>
                account.phone.replace(toDeleteRegexPhoneNumberMask, '') ===
                customer.phone.replace('-', ''),
            )
        if (businessAccount) {
          invoice?.setValue?.('customer_account_id', businessAccount.id)
          self.setCustomerData(businessAccount)
        }
      } else {
        if (self.customer.phone?.length >= 0) {
          /**
           * To avoid unnecessary re-render.
           */
          self.customer.setValue('contact', '')
          self.customer.setValue('address', '')
          if (invoice.customer_account_id) {
            self.resetInvoiceFields(['customer_account_id'])
            self.customer.resetWithPhoneNumber()
          }
          if (self.businessAccountsUsers.length) self.businessAccountsUsers = []
        }
      }
    },
  }))
